// src/components/HomepageComponents/NavigationBar.js
import React, { useEffect, useRef, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import matchmedicLogo from '../../images/matchmedic_logo3.png';
// shrinked logo
import mmLogoShrinked from '../../images/mm_logo_shrinked.png'; // <-- add this asset

 const NavigationBar = ({
   onHeightChange = null,
   className = '',
   // NEW: allow RecPrototype to drive a mobile tab bar inside the nav
   isRecPrototypePage = false,
   isTabBar = false,
   options = [],
   activeIndex = 0,
   underlinePosition = 0,   // 0..100 across options
   onTabClick = () => {},
  }) => {  const navbarRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // mobile detector (same pattern we used elsewhere)
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    h();
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  // report height (optional if you're not using the spacer anymore)
  useEffect(() => {
    if (!onHeightChange || !navbarRef.current) return;
    const measure = () => onHeightChange(navbarRef.current.getBoundingClientRect().height);
    measure();
    const t = setTimeout(measure, 80);
    window.addEventListener('resize', measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', measure);
    };
  }, [onHeightChange]);

  // a single place to control the width & margins of nav content
  const innerWidth = 'mx-auto w-full lg:w-3/5';

  // ---- EmbeddedTabBar (ported from old NavBar) ----
  const optionColors = [
    { main: '#111827', text: '#111827', selectedText: '#FFFFFF' },
    { main: '#111827', text: '#111827', selectedText: '#FFFFFF' },
    { main: '#111827', text: '#111827', selectedText: '#FFFFFF' },
  ];
  const currentBubbleColor = (() => {
    if (!options.length) return '#3B82F6';
    const exact = (underlinePosition * options.length) / 100;
    const l = Math.floor(exact);
    const r = Math.min(l + 1, options.length - 1);
    const t = exact - l;
    const toRgb = (h) => ({ r: parseInt(h.slice(1,3),16), g: parseInt(h.slice(3,5),16), b: parseInt(h.slice(5,7),16) });
    const mix = (a,b,t) => Math.round(a*(1-t)+b*t);
    const c1 = toRgb(optionColors[l]?.main || '#2196F3');
    const c2 = toRgb(optionColors[r]?.main || '#2196F3');
   return `rgb(${mix(c1.r,c2.r,t)}, ${mix(c1.g,c2.g,t)}, ${mix(c1.b,c2.b,t)})`;
    })();
    const getTextColor = (idx) => {
    const w = 100 / (options.length || 1);
    const center = idx * w + w / 2;
    const dist = Math.abs(underlinePosition + w / 2 - center);
    const level = 1 - Math.min(dist / w, 1);
    const parse = (c) =>
      c.startsWith('#')
        ? { r: parseInt(c.slice(1,3),16), g: parseInt(c.slice(3,5),16), b: parseInt(c.slice(5,7),16) }
        : (() => { const m = c.match(/\d+/g).map(Number); return { r:m[0], g:m[1], b:m[2] } })();
    const n = parse(optionColors[idx]?.text || '#666');
    const a = parse(optionColors[idx]?.selectedText || '#fff');
    const r = Math.round(n.r * (1 - level) + a.r * level);
    const g = Math.round(n.g * (1 - level) + a.g * level);
    const b = Math.round(n.b * (1 - level) + a.b * level);
    return `rgb(${r},${g},${b})`;
  };


  return (
    <nav ref={navbarRef} className={`sticky top-0 z-30 bg-gray-100 ${className}`}>
      {/* HEADER ROW (centered, constrained) */}
      <div className={`${innerWidth} px-4 sm:px-6 lg:px-8`}>
      <div className={`flex items-center justify-start lg:justify-between ${
        isRecPrototypePage && isMobile ? 'py-1' : 'py-2'
      }`}>          
      {/* LEFT: Logo */}
          <HashLink smooth to="/" className="flex items-center hover:opacity-90 transition-opacity shrink-0">
      <img
        src={isRecPrototypePage && isMobile ? mmLogoShrinked : matchmedicLogo}
        alt="MatchMedic"
        className={`w-auto ${
          // Mobile only: smaller logo for RecPrototype; Desktop: stay identical to other pages.
          isRecPrototypePage && isMobile ? 'h-5' : 'h-7'
        } md:h-5`}
      />
          </HashLink>

          {/* CENTER: Desktop links */}
          <div className="hidden lg:flex items-center gap-8">
            <HashLink smooth to="/about"   className="text-xs font-bold text-gray-800">About</HashLink>
            <HashLink smooth to="/blog-showroom"    className="text-xs font-bold text-gray-800">Blog</HashLink>
            <HashLink smooth to="/contact" className="text-xs font-bold text-gray-800">Contact</HashLink>
          </div>

          {/* RIGHT: Start Now (desktop only) */}
  <div className="hidden lg:flex">
    <HashLink
      smooth
      to="/onboarding"
      className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-xs font-semibold bg-gray-900 text-white"
    >
      Start Now<span aria-hidden className="ml-1">→</span>
    </HashLink>
  </div>

          {/* RIGHT: Start Now */}
          {/* --- MOBILE embedded TabBar (if requested) --- */}
          {isTabBar && isMobile && options.length > 0 && (
            <div className="flex-1 mx-2 h-10 relative overflow-hidden">
              <div className="flex h-full relative">
                <div
                  className="absolute rounded-t-lg transition-all duration-300 ease-out"
                  style={{
                    marginLeft: `${underlinePosition}%`,
                    width: `${100 / options.length}%`,
                    top: 0,
                    bottom: '-1.5rem',
                    backgroundColor: currentBubbleColor,
                  }}
                />
                {options.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => onTabClick(idx)}
                    disabled={idx === activeIndex}
                    style={{ color: getTextColor(idx), transition: 'color 0.3s ease-out' }}
                    className="flex-1 py-2 text-center text-sm font-bold relative z-10"
                  >
                    Option {idx + 1}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Mobile hamburger */}
          <button
            className="lg:hidden ml-auto p-2 rounded-md text-gray-800"
            onClick={() => setIsOpen((p) => !p)}
            aria-label="Toggle navigation menu"
            aria-expanded={isOpen}
          >
            <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
              {isOpen ? (
                <path fillRule="evenodd" clipRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"/>
              ) : (
                <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* MOBILE DROPDOWN (same centered width) */}
      <div
        className={`
          lg:hidden transition-[max-height,opacity] duration-300 ease-in-out overflow-hidden
          ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
        `}
      >
        <div className={`${innerWidth} px-4 sm:px-6 lg:px-8 pb-4`}>
          <div className="flex flex-col gap-1">
            <HashLink smooth to="/about"   className="py-2 text-base font-medium" onClick={() => setIsOpen(false)}>About</HashLink>
            <HashLink smooth to="/blog"    className="py-2 text-base font-medium" onClick={() => setIsOpen(false)}>Blog</HashLink>
            <HashLink smooth to="/contact" className="py-2 text-base font-medium" onClick={() => setIsOpen(false)}>Contact</HashLink>
            <HashLink
              smooth
              to="/onboarding"
              className="mt-2 inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold bg-gray-900 text-white"
              onClick={() => setIsOpen(false)}
            >
              Start Now<span aria-hidden className="ml-1">→</span>
            </HashLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
